import React from "react";
import { Link, Route } from "react-router-dom";
import paths from "../../routes/paths";
import { textCodes, titleCodes, imageCodes } from "../../template_codes/mamamyanmar/home_page_codes";

function Home() {
    return (
        <div>

            {/*         paragraph section           */}
            <div className="container w-full md:w-3/5 lg:w-3/5 xl:w-3/5 2xl:w-3/5 py-10">
                <p className="text-justify px-4">{textCodes.about.text}</p>
            </div>
            {/*         end of paragraph section           */}

            {/*         category section           */}
            <div className="container w-5/6 md:w-4/6 lg:w-4/6 xl:w-4/6 2xl:w-3/6 pt-10 pb-16">
                <h1 className="font-bold text-xl text-center pb-10">{titleCodes.searchbyCategory.title}</h1>
                <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 gap-x-4 md:gap-x-8 lg:gap-x-8 xl:gap-x-8 2xl:gap-x-8 gap-y-4">
                    <div className="m-2">
                        <a href="https://mamamyanmar.com/?cat=furniture"><img src={imageCodes.furniture.image} alt="furniture" className="hover:-translate-y-1 duration-300 ..."></img>
                        <p className="font-semibold text-center">Furniture</p></a>
                    </div>
                    <div className="m-2">
                        <a href="https://mamamyanmar.com/?cat=lightning"><img src={imageCodes.lighting.image} alt="lighting" className="hover:-translate-y-1 duration-300 ..."></img>
                        <p className="font-semibold text-center">Lighting</p></a>
                    </div>
                    <div className="m-2">
                        <a href="https://mamamyanmar.com/?cat=accessories"><img src={imageCodes.accessories.image} alt="accessories" className="hover:-translate-y-1 duration-300 ..."></img>
                        <p className="font-semibold text-center">Accessories</p></a>
                    </div>
                    <div className="m-2">
                        <a href="https://mamamyanmar.com/?cat=fashion"><img src={imageCodes.fashion.image} alt="fashion" className="hover:-translate-y-1 duration-300 ..."></img>
                        <p className="font-semibold text-center">Fashion</p></a>
                    </div>
                </div>
            </div>
            {/*         end of category section           */}

            {/*           brand section              */}
            {/* <div className="pb-16">
                <h1 className="font-bold text-xl text-center">Search by brand</h1>
                <div className="carousel carousel-end rounded-box">
                    <div className="carousel-item" id="item1">
                        <img src="https://www.creativefabrica.com/wp-content/uploads/2020/12/11/Furniture-Icon-Vector-Illustration-Graphics-7114328-2-580x386.png" alt="Burger" />
                    </div>
                    <div className="carousel-item" id="item2">
                        <img src="https://www.creativefabrica.com/wp-content/uploads/2020/12/11/Furniture-Icon-Vector-Illustration-Graphics-7114328-2-580x386.png" alt="Burger" />
                    </div>
                    <div className="carousel-item" id="item3">
                        <img src="https://www.creativefabrica.com/wp-content/uploads/2020/12/11/Furniture-Icon-Vector-Illustration-Graphics-7114328-2-580x386.png" alt="Burger" />
                    </div>
                    <div className="carousel-item" id="item4">
                        <img src="https://www.creativefabrica.com/wp-content/uploads/2020/12/11/Furniture-Icon-Vector-Illustration-Graphics-7114328-2-580x386.png" alt="Burger" />
                    </div>
                    <div className="carousel-item" id="item5">
                        <img src="https://www.creativefabrica.com/wp-content/uploads/2020/12/11/Furniture-Icon-Vector-Illustration-Graphics-7114328-2-580x386.png" alt="Burger" />
                    </div>
                    <div className="carousel-item" id="item6">
                        <img src="https://www.creativefabrica.com/wp-content/uploads/2020/12/11/Furniture-Icon-Vector-Illustration-Graphics-7114328-2-580x386.png" alt="Burger" />
                    </div>
                </div>
                <div className="flex justify-center w-full py-2 gap-2">
                    <a href="#item1" className="btn btn-xs bg-white text-black border-0 hover:text-white">○</a>
                    <a href="#item2" className="btn btn-xs bg-white text-black border-0 hover:text-white">○</a>
                    <a href="#item3" className="btn btn-xs bg-white text-black border-0 hover:text-white">○</a>
                    <a href="#item4" className="btn btn-xs bg-white text-black border-0 hover:text-white">○</a>
                    <a href="#item5" className="btn btn-xs bg-white text-black border-0 hover:text-white">○</a>
                    <a href="#item6" className="btn btn-xs bg-white text-black border-0 hover:text-white">○</a>

                </div>
            </div> */}
            {/* <div className="container w-5/6 md:w-4/6 lg:w-4/6 xl:w-4/6 2xl:w-3/6 pb-16">
                <h1 className="font-bold text-xl text-center pb-10">{titleCodes.searchbyBrand.title}</h1>
                <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 gap-x-8">
                    <div className="m-2">
                        <img src={imageCodes.furniture.image} alt="Brand" className="hover:-translate-y-1 duration-300 ..."></img>
                        <p className="font-semibold text-center">Brand 1</p>
                    </div>
                    <div className="m-2">
                        <img src={imageCodes.lighting.image} alt="Brand" className="hover:-translate-y-1 duration-300 ..."></img>
                        <p className="font-semibold text-center">Brand 2</p>
                    </div>
                    <div className="m-2">
                        <img src={imageCodes.accessories.image} alt="Brand" className="hover:-translate-y-1 duration-300 ..."></img>
                        <p className="font-semibold text-center">Brand 3</p>
                    </div>
                    <div className="m-2">
                        <img src={imageCodes.fashion.image} alt="Brand" className="hover:-translate-y-1 duration-300 ..."></img>
                        <p className="font-semibold text-center">Brand 4</p>
                    </div>
                </div>
            </div> */}
            {/*             end of brand section            */}

            {/*             popular searches             */}
            <div className="container w-full md:w-3/6 lg:w-3/6 xl:w-3/6 2xl:w-3/6 pb-16">
                <h1 className="font-bold text-xl text-center pb-10">{titleCodes.popularSearches.title}</h1>
                <div className="flex gap-x-8 p-4 mb-4 bg-gray-100 mx-1">
                    <a href="https://mamamyanmar.com/product/clarz8n5i18517201s6d40iaoyw"><img src={imageCodes.product1.image} width={120} height={140} className="rounded-lg hover:-translate-y-1 duration-300 ..." alt="product"></img></a>
                    <div>
                        <a href="https://mamamyanmar.com/product/clarz8n5i18517201s6d40iaoyw">
                        <p className="m-2 p-1 bg-gray-200 rounded-full">K 65,000</p>
                        <p className="p-2 font-semibold">Luna Chair</p>
                        <p className="p-2 text-sm">Brand: Woven Objects</p></a>
                    </div>
                </div>
                <div className="flex gap-x-8 p-4 mb-4 bg-gray-100 mx-1">
                    <a href="https://mamamyanmar.com/product/clb33akr611464601s6t3ezjb8l"><img src={imageCodes.product2.image} width={120} height={140} className="rounded-lg hover:-translate-y-1 duration-300 ..." alt="product"></img></a>
                    <div>
                        <a href="https://mamamyanmar.com/product/clb33akr611464601s6t3ezjb8l">
                        <p className="m-2 p-1 bg-gray-200 rounded-full">K 8,000</p>
                        <p className="p-2 font-semibold">Market Basket</p>
                        <p className="p-2 text-sm">Brand: Pakkou</p></a>
                    </div>
                </div>
                <div className="flex gap-x-8 p-4 mb-4 bg-gray-100 mx-1" >
                    <a href="https://mamamyanmar.com/product/clasyg6my115901s65x7i4ep8"><img src={imageCodes.product3.image} width={120} height={140} className="rounded-lg hover:-translate-y-1 duration-300 ..." alt="product"></img></a>
                    <div>
                        <a href="https://mamamyanmar.com/product/clasyg6my115901s65x7i4ep8">
                        <p className="m-2 p-1 bg-gray-200 rounded-full">K 20,000</p>
                        <p className="p-2 font-semibold">Inya Hanging Lamp </p>
                        <p className="p-2 text-sm">Brand: Illuminate</p></a>
                    
                    </div>
                </div>
            </div>
            {/*             end of popular searches             */}

            {/*           3 tab section            */}
            <div className="container w-3/5">
                <div className="flex gap-x-8 place-content-center">
                    <a href="https://mamamyanmar.com/"><p className="text-center m-2 py-2 px-4 bg-gray-200 rounded-lg hover:animate-bounce">All Products</p></a>
                    <Link to={paths.contact}><p className="text-center m-2 py-2 px-4 bg-gray-200 rounded-lg hover:animate-bounce">Contact mama</p></Link>
                    <a href="https://mamamyanmar.com/terms"><p className="text-center m-2 py-2 px-4 bg-gray-200 rounded-lg hover:animate-bounce">Terms & Conditions</p></a>
                </div>
            </div>
            {/*           end of 3 tab section            */}
        </div >
    );
}

export default Home;